import { clientFetch } from '@biw/client-fetch';
import { addError } from 'dux/errors';
import Errors from 'dux/errors/errors';

/*******************************************************************************
 *  Initial State
 */
const initialState = {
    rules: {
        key: null,
        value: null
    }
};

/*******************************************************************************
 *  Action Types
 */
export const RULES = 'rules';
export const SET_RULES = 'SET_RULES';

/*******************************************************************************
 *  Action Creators
 */
export function fetchRules( programView ) {
    const { programId, groupId, role } = programView;
    return dispatch => {
        return clientFetch( {
            url: `/api/v1.0/program/rules/${ programId }/${ groupId }/${ role }`,
            type: RULES,
            catchError: true
        } ).then( rules => {
            dispatch( setRules( rules ) );
        } ).catch( error => {
            dispatch( addError( error, Errors.ERROR_GOAL_SELECTION_FETCHLEVELS ) );
        } );
    };
}

export function setRules( rules ) {
    return {
        type: SET_RULES,
        rules
    };
}

/*******************************************************************************
 *  Reducers
 */
export default function welcome( state = initialState, action ) {
    switch ( action.type ) {
        case SET_RULES:
            return {
                ...state,
                rules: action.rules
            };
        default:
            return state;
    }
}
